<template src="./NotificationsCreate.html"> </template>
<script>

import { mapActions, mapState } from 'vuex';

import WeatherStationCreate from '@/modules/WeatherStation/WeatherStationCreate/WeatherStationCreate.vue';

export default {
    name: 'NotificationsCreate',
    components: {
        WeatherStationCreate,
    },
    data() {
        return {

            // Form Validation
            formValidation: true,
            textRules: [
                v => !!v || 'Item is required'
            ],

            showCreateVirtualStation: false,
            // newVirtualStation: { name: '', status: false, latitude: null, longitude: null },

            tableHeader: [{text: "Virtual Weather Station", value: 'station'}, {text: "Description", value: "description"}, { text: "Climate Indicator", value: "climateindicator"}, {text: "Start Date", value: 'startDate'}, {text: "End Date", value: 'endDate'}, {text: "Send Alert every", value: 'sendalert'}, {text: "Day (s)", value: 'days'}],

            newNotification: {user: '', ws: '', app: '', send_email: false, send_sms: false, description: '', variable: '', begin: '', end: ''},

            dataAnalysisFullScreen: false,
            
            variables: [],

            periodicities: [{id: 'daily', description: 'Daily'}], //[{id: 'weekly', description: 'Week'}, {id: 'monthly', description: 'Month'}, {id: 'acc', description: 'Accumulate units'}],

            // days: [{id: '0', description: 'Sunday'}, { id: '1', description: 'Monday' }, {id: '2', description: 'Tuesday'}, {id: '3', description: 'Wednesday'}, {id: '4', description: 'Thursday'}, {id: '5', description: 'Friday'}, {id: '6', description: 'Sunday'}],
        }
    },
    computed: {
        
        ...mapState({
            variableConfig: state => state.variables,
            ws: state => state.ws.ws,
            user: state => state.social.user,

            notificationCreating: state => state.notifications.notificationCreating,
            
        }),

        notificationCreatingStatus() {
            //if (this.notificationCreating.data.name === undefined) return this.wsCreating;
            console.log('notificationCreatingStatus: ', this.notificationCreating)
            if (this.notificationCreating.data.code == 'SUCCESS')
                this.createAlert({message: 'Notification has been successfully created!', type: 'success'});
            else if (this.notificationCreating.data.code == 'ERROR')
                this.createAlert({message: 'Error creating Notification. Please try again or contact the system admin!', type: 'error'});
            
            return this.notificationCreating;
        },

        getWs() {
            if (this.ws.length > 0)
                return this.ws;
            return []
        },

        getVariables() {
            let keys = Object.keys(this.variableConfig).filter(item => !item.includes('His'));
            keys = keys.filter(item => item == 'totR' || item == 'chillH' || item == 'chillP' || item == 'chill-portions' || item == 'chillU' || item == 'chill-units')
            return keys.map(item => {
                this.variableConfig[item]['id'] = item
                return this.variableConfig[item];
            });
        },
    },
    methods: {

        ...mapActions({
            setVirtualStationLatLon: 'setVirtualStationLatLon',
            setAlert: 'setAlert',

            setNotification: 'createNotification',
            getNotifications: 'getNotifications',

            resetNotificationsCreating: 'resetNotificationsCreating',
        }),

        createAlert(alert) {
            this.setAlert(alert);

            if (alert.type == 'success') {
                this.getNotifications();
                this.onBackClick();
            }
            this.resetNotificationsCreating();
        },

        onSaveNotification() {

            this.$refs.form.validate();
            
            if (this.newNotification.variable.id != undefined) {
                if (this.user != null) {
                    this.newNotification.variable = this.newNotification.variable.id;
                    this.newNotification.ws = this.newNotification.ws._id;
                    this.newNotification.app = 'test';
                    this.newNotification.user = this.user._id;
                    this.setNotification(this.newNotification);
                }
            }
        },

        onBackClick() {
            if (this.$refs.form)
                this.$refs.form.resetValidation();
            this.newNotification = {user: '', ws: '', app: '', send_email: false, send_sms: false, description: '', variable: '', begin: '', end: ''},
            this.$emit('clicked', '');
        },
        
        // create vws module
        onCloseCreateVirtualStation(value) {
            this.showCreateVirtualStation = value;
        },

    },
}
</script>

<style lang="scss" src="./NotificationsCreate.scss"> </style>